/**
 * This file is used for setting up and connecting to Prismic.
 */

module.exports = {
  // The domain name of your Prismic repository. This can be found in the URL of
  // your repository.
  //
  // Example: 'my-repo' if your Prismic repository URL is 'my-repo.prismic.io'.
  prismicRepo: "grub24",

  // The default language for content in your Prismic repository.
  defaultLanguage: "en-gb",

  // All available languages for content in your Prismic repository.
  langs: ["en-gb", "ar-ae"],

  // Language prefix mapping for URL generation
  langPrefixes: {
    "en-gb": "", // English is the default, no prefix
    "ar-ae": "ar-ae", // Arabic UAE pages under /ar-ae
  },

  // RTL languages
  rtlLanguages: ["ar-ae"],
}
